/*
 * @Date: 2023-09-14 11:27:11
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-02-05 16:46:01
 * @FilePath: /nicee-web-tw/src/api/voice-room.js
 * @Description: 语音房接口
 */
import { request, post } from '@/axios';

/**
 * @description: 获取声网配置
 * @param {roomUid:number|string} params
 * @return {*}
 */
export function getToken(params) {
  return request({
    url: '/voiceRoom/normal/get/token',
    method: 'get',
    params
  });
}

/**
 * @description: 语音房详情
 * @param {roomUid:number|string} params
 * @return {*}
 */
export function getRoomInfo(params) {
  return request({
    url: '/voiceRoom/normal/roomInfo',
    method: 'get',
    params
  });
}

/**
 * @description:获取在线成员
 * @param {"keywords": "","orderByLevel": true,"pageIndex": 0,"roomUid": ""} params
 * @return {*}
 */
export function getOnlineMembers(params) {
  return post('/voiceRoom/getOnlineMembers', params);
}

/**
 * @description: 获取所有emoji表情
 * @param {*} params
 * @return {*}
 */
export function getEmojiList(params) {
  return request({
    url: '/voiceRoom/faceEmoji/all',
    method: 'get',
    params
  });
}

/**
 * @description: 獲取禮物列表
 * @param {*} params
 * @return {*}
 */
export function getGiftList(params) {
  return request({
    url: '/box/list',
    method: 'get',
    params
  });
}

/**
 * @description: 獲取個人背包
 * @param {*} params
 * @return {*}
 */
export function getPackSack(params) {
  return request({
    url: '/box/packSack',
    method: 'get',
    params
  });
}

/**
 * @description: 送禮物或開寶箱
 * @param {*} params
 * @return {*}
 */
export function sendGift(params) {
  return post('/box/send', params);
}

/**
 * @description: 獲取請求列表
 * @param {*} params
 * @return {*}
 */
export function askingMicQueue(params) {
  return request({
    url: '/voiceRoom/admin/get/askingMicQueue',
    method: 'get',
    params
  });
}

/**
 * @description: 拒絕上麥申請
 * @param {*} params
 * @return {*}
 */
export function rejectApplyMic(params) {
  return post('/voiceRoom/admin/act', params);
}

/**
 * @description: 同意上麥申請
 * @param {*} params
 * @return {*}
 */
export function agreeApplyMic(params) {
  return post('/voiceRoom/admin/act', params);
}

/**
 * @description: 獲取用戶詳情
 * @param {*} params
 * @return {*}
 */
export function getUserInfo(params) {
  return request({
    url: '/user/detail/info',
    method: 'get',
    params
  });
}

/**
 * @description: 獲取禮物牆
 * @param {*} params
 * @return {*}
 */
export function getGiftWall(params) {
  return post('/gift/wall', params);
}

/**
 * @description: 禁言-取消
 * @return {*}
 * @param {*} {
  "accounts": [],
  "muteTime": 30,禁言时间(单位: 秒; 为0时表示取消禁言，4294967295为永久禁言),示例值(30)
  "roomUid": ""
}
 */
export function forbidMsg(params) {
  return post('/voiceRoom/forbidMsg', params);
}

/**
 * @description: 獲取禁言用戶列表
 * @param {*} {
  "account": "",
  "roomUid": ""
}
 * @return {*}
 */
export function getMutedAccounts(params) {
  return post('/voiceRoom/getMutedAccounts', params);
}

/**
 * @description: 加入房間
 * @param {*} params
 * @return {*}
 */
export function joinRoom(params) {
  return post('/voiceRoom/normal/act', params);
}

/**
 * @description: 获取房间管理员
 * @param {*} params
 * @return {*}
 */
export function getMyVoiceRoomAdmin(params) {
  return request({
    url: '/voiceRoom/manager/adminList',
    method: 'get',
    params
  });
}

/**
 * @description: 设置房间管理员
 * @param {*} params
 * @return {*}
 */
export function setMyVoiceRoomAdmin(params) {
  return request({
    url: '/voiceRoom/admin/setAdmin',
    method: 'get',
    params
  });
}

/**
 * @description: 取消房间管理员
 * @param {*} params
 * @return {*}
 */
export function cancelMyVoiceRoomAdmin(params) {
  return request({
    url: '/voiceRoom/admin/unsetAdmin',
    method: 'get',
    params
  });
}

/**
 * @description: 查詢在線用戶
 * @param {*} params
 * @return {*}
 */
export function searchOnlineMembers(params) {
  return post('/voiceRoom/searchOnlineMembers', params);
}

/**
 * @description: 獲取送禮積分值
 * @param {*} params
 * @return {*}
 */
export function getCharmVal(roomId) {
  return request({
    url: '/voiceRoom/getCharmVal/' + roomId,
    method: 'get'
  });
}

/**
 * @description: 獲取語音房排名
 * @param {*} params
 * @return {*}
 */
export function getVoiceRoomRank(params) {
  return post('/rank/voiceRoomRank', params);
}

/**
 * @description: 获取手气榜单
 * @param {*} params
 * @return {*}
 */
export function getVoiceRoomLuckRank(params) {
  return post('/rank/voiceRoomLuckRank', params);
}

/**
 * @description: 心跳连接
 * @param {*} params
 * @return {*}
 */
export function keepConnect(params) {
  return request({
    url: '/voiceRoom/manager/dynamic',
    method: 'get',
    params
  });
}

/**
 * @description: 获取房间座位
 * @param {*} params
 * @return {*}
 */
export function getRoomSeat(params) {
  return request({
    url: '/voiceRoom/getRoomSeat',
    method: 'get',
    params
  });
}

/**
 * @description: 获取在线用户
 * @param {*} params
 * @return {*}
 */
export function getOnlineUsers(params) {
  return request({
    url: '/voiceRoom/getOnlineUsers',
    method: 'get',
    params
  });
}

/**
 * @description: 改变座位
 * @param {*} params
 * @return {*}
 */
export function changeSeat(params) {
  return post('/voiceRoom/normal/changerSeat', params);
}

/**
 * @description: 申請上麥
 * @param {roomUid:number|string} params
 * @return {*}
 */
export function applyMic(params) {
  return post('/voiceRoom/normal/act', params);
}

/**
 * @description: 取消申请上麦
 * @param {*} params
 * @return {*}
 */
export function cancelApplyMic(params) {
  return post('/voiceRoom/normal/act', params);
}

/**
 * @description: 主持人上麥
 * @param {*} params
 * @return {*}
 */
export function hostTakeSeat(params) {
  return post('/voiceRoom/admin/act', params);
}

/**
 * @description: 下麦
 * @param {*} params
 * @return {*}
 */
export function leaveSeat(params) {
  return post('/voiceRoom/normal/act', params);
}

/**
 * @description: 踢下麥
 * @param {*} params
 * @return {*}
 */
export function forceLeaveMic(params) {
  return post('/voiceRoom/admin/act', params);
}

/**
 * @description: 开麦/闭麦
 * @param {*} { roomUid: this.roomId, mic: 1 } 1/开 0/关
 * @return {*}
 */
export function switchMic(params) {
  return post('/voiceRoom/normal/micChanger', params);
}

/**
 * @description: 关闭用户麦克风
 * @param {*} params
 * @return {*}
 */
export function closeUserMic(params) {
  return post('/voiceRoom/admin/micChanger', params);
}

/**
 * @description: 取消关闭麦克风
 * @param {*} params
 * @return {*}
 */
export function openUserMic(params) {
  return post('/voiceRoom/admin/micChanger', params);
}

/**
 * @description: 甩麦
 * @param {*} params
 * @return {*}
 */
export function giveMic(params) {
  return post('/voiceRoom/admin/micToSingle', params);
}

/**
 * @description: 寶箱說明
 * @param {*} roomId
 * @return {*}
 */
export function getGiftBox() {
  return request({
    url: '/voiceRoom/getGiftBox',
    method: 'get'
  });
}
